import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import request from '@/request';
import download from '@/request/download';
// import { ElMessage } from 'element-plus'
import CommonTable from '@/components/CommonTable';
import variables from '@/styles/variables.module.scss';
export default {
  components: {
    CommonTable: CommonTable
  },
  data: function data() {
    return {
      resultDialog: false,
      activeName: 'first',
      defaultColumns: [{
        label: '行号',
        width: '96',
        render: function render(h, row) {
          return h('span', {
            style: {
              paddingLeft: '40px'
            }
          }, row.row);
        }
      }, {
        label: '运单号',
        width: '328',
        prop: 'trackingNumber'
      }, {
        label: '原因描述',
        prop: 'desc'
      }],
      options: {
        index: false,
        size: 'large',
        stripe: false,
        align: 'left',
        multipleRowSelect: false,
        commonStyle: {},
        headStyle: {
          background: variables.rowBg
        },
        rowStyle: this.tableRowStule,
        selectionChange: this.selectionChange,
        height: '100%'
      },
      detailId: '',
      detailInfo: null
    };
  },
  // watch: {
  //   '$root.isuploadDialog': {
  //     deep: true,
  //     handler: function(val) {
  //       if (val) {
  //         this.uploadDialog = val
  //       }
  //     }
  //   }
  // },
  computed: {
    abnormals: {
      get: function get() {
        if (!this.detailInfo) return [];
        if (!this.detailInfo.isFixed && !this.detailInfo.isRowData) {
          // 草单
          if (!this.detailInfo.logFileDetailList) return [];
          return this.detailInfo.logFileDetailList.filter(function (item) {
            return !item.isRepeat;
          });
        } else {
          if (!this.detailInfo.logDetailList) return [];
          return this.detailInfo.logDetailList.filter(function (item) {
            return !item.isRepeat;
          });
        }
      }
    },
    repeats: {
      get: function get() {
        if (!this.detailInfo) return [];
        if (!this.detailInfo.isFixed && !this.detailInfo.isRowData) {
          // 草单
          if (!this.detailInfo.logFileDetailList) return [];
          return this.detailInfo.logFileDetailList.filter(function (item) {
            return item.isRepeat;
          });
        } else {
          if (!this.detailInfo.logDetailList) return [];
          return this.detailInfo.logDetailList.filter(function (item) {
            return item.isRepeat;
          });
        }
      }
    },
    isDraft: {
      get: function get() {
        if (!this.detailInfo) return false;
        if (!this.detailInfo.isFixed && !this.detailInfo.isRowData) {
          return true;
        }
        return false;
      }
    },
    columns: {
      get: function get() {
        if (!this.detailInfo) return this.defaultColumns;
        if (!this.detailInfo.isFixed && !this.detailInfo.isRowData) {
          // 草单
          return [{
            label: '序号',
            width: '96',
            render: function render(h, row) {
              return h('span', {
                style: {
                  paddingLeft: '40px'
                }
              }, row.row);
            }
          }, {
            label: '文件名',
            width: '328',
            prop: 'fileName'
          }, {
            label: '原因描述',
            prop: 'desc'
          }];
        } else {
          return this.defaultColumns;
        }
      }
    }
  },
  methods: {
    selectionChange: function selectionChange() {},
    show: function show(fid) {
      this.detailId = fid;
      this.httpGetDetail();
      this.resultDialog = true;
    },
    onDialogClosed: function onDialogClosed() {},
    onCancelClick: function onCancelClick() {
      this.resultDialog = false;
    },
    onExoportClick: function onExoportClick() {
      download({
        url: '/api/v1/upload/download/desc',
        method: 'GET',
        params: {
          id: this.detailId
        }
      }, {
        'type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'fileType': ''
      }).then(function (res) {});
    },
    httpGetDetail: function httpGetDetail() {
      var _this = this;
      request({
        url: '/api/v1/upload/query/log/history/detail/' + this.detailId,
        method: 'GET',
        params: {
          pageNo: 1,
          pageSize: 100000
        }
      }).then(function (res) {
        _this.detailInfo = res;
      });
    },
    getFileTypeStr: function getFileTypeStr(type) {
      if (!type || type.length === 0) return '';
      if (type === 'OB') return '个人物品申报(B类)出口报关';
      if (type === 'OC') return '低价商品出口报关';
      if (type === 'OD') return '正式申报类货物(D类)出口报关';
      if (type === 'IB') return '个人物品申报(B类)进口报关';
      if (type === 'IC') return '低价商品进口报关';
      if (type === 'ID') return '正式申报类货物(D类)进口报关';
      return '';
    },
    handleClick: function handleClick() {}
  }
};